/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description chomp
 */

import { isNumber } from '@zcode/utils'

/**
 * chomp floating point precision number to a finite precision
 *
 * @param {number} num
 * @param {number} precision
 * @returns {number}
 */
function chomp(num: number, precision?: number): number
function chomp(num: null, precision?: number): null
function chomp(num: number | null, precision?: number): number | null
function chomp(num: number | null, precision = 6) {
  if (!isNumber(num)) {
    return null
  }

  const numsArr = num.toString().split('.')
  if (numsArr.length > 1) {
    numsArr[1] = numsArr[1].slice(0, precision)
    return Number.parseFloat(numsArr.join('.'))
  }
  return num
}

export default chomp
